import React from 'react'
import { MainLayout } from 'layout'
import { withRequireAuthentication } from 'hocs'
import {
  Top5Page,
  PursuitsPage,
  ImGoodAtPage,
  DidYouKnowPage,
  MoreAboutMePage,
  TermsAcceptancePage,
  EmailVerificationPage,
  BasicsPage,
  InitiativeSubmissionPage,
  SnapshotPage,
  PublicProfilePage,
  TalentPlaylistsPage,
  EnterprisePlaylistPage,
  AuthenticationCallback,
  MediaPage,
  InitiativeManagementPage,
  RedirectInitiativeAuthService
} from 'smart-components'

import LandingPage from 'smart-components/authentication-controller/landing/Landing'

export interface IRouteDefinition {
  id: string
  path: string
  component: any
}

const routes: IRouteDefinition[] = [
  {
    id: 'root',
    path: '/',
    component: withRequireAuthentication(() => <LandingPage />)
  },
  {
    id: 'topFives',
    path: '/top-fives',
    component: withRequireAuthentication(() => (
      <MainLayout>
        <Top5Page />
      </MainLayout>
    ))
  },
  {
    id: 'terms',
    path: '/terms',
    component: withRequireAuthentication(TermsAcceptancePage)
  },
  {
    id: 'emailVerification',
    path: '/email-verification',
    component: withRequireAuthentication(EmailVerificationPage)
  },
  {
    id: 'theBasics',
    path: '/the-basics',
    component: withRequireAuthentication(() => (
      <MainLayout>
        <BasicsPage />
      </MainLayout>
    ))
  },
  {
    id: 'enterpriseFlow.questions',
    path: '/enterprise/:enterpriseId/:code/questions',
    component: withRequireAuthentication(InitiativeSubmissionPage)
  },
  {
    id: 'didYouKnow',
    path: '/did-you-know',
    component: withRequireAuthentication(() => (
      <MainLayout>
        <DidYouKnowPage />
      </MainLayout>
    ))
  },
  {
    id: 'imGoodAt',
    path: '/im-good-at',
    component: withRequireAuthentication(() => (
      <MainLayout>
        <ImGoodAtPage />
      </MainLayout>
    ))
  },
  {
    id: 'moreAboutMe',
    path: '/more-about-me',
    component: withRequireAuthentication(() => (
      <MainLayout>
        <MoreAboutMePage />
      </MainLayout>
    ))
  },
  {
    id: 'pursuits',
    path: '/pursuits',
    component: withRequireAuthentication(() => (
      <MainLayout>
        <PursuitsPage />
      </MainLayout>
    ))
  },
  {
    id: 'media',
    path: '/media',
    component: withRequireAuthentication(() => (
      <MainLayout>
        <MediaPage />
      </MainLayout>
    ))
  },
  {
    id: 'snapshot',
    path: '/snapshot',
    component: withRequireAuthentication(() => (
      <MainLayout>
        <SnapshotPage />
      </MainLayout>
    ))
  },
  {
    id: 'profile',
    path: '/profile/:userId',
    component: PublicProfilePage
  },
  {
    id: 'profile-embedded',
    path: '/profile/:userId/embedded/:enterpriseId',
    component: PublicProfilePage
  },
  {
    id: 'talent-playlists',
    path: '/talent-playlists',
    component: withRequireAuthentication(() => (
      <MainLayout>
        <TalentPlaylistsPage />
      </MainLayout>
    ))
  },
  {
    id: 'enterprise-playlists',
    path: '/enterprise/:enterpriseId/playlist/:playlistCode',
    component: withRequireAuthentication(
      ({ enterpriseId, playlistCode }: { enterpriseId: string; playlistCode: string }) => {
        return (
          <MainLayout>
            <EnterprisePlaylistPage enterpriseId={enterpriseId} playlistCode={playlistCode} />
          </MainLayout>
        )
      }
    )
  },
  {
    id: 'authentication.callback',
    path: '/callback',
    component: AuthenticationCallback
  },
  {
    id: 'authentication.callback-initiative',
    path: '/callback/enterprise/:enterpriseId/:submissionLinkCode/management',
    component: AuthenticationCallback
  },
  {
    id: 'initiatives-management',
    path: '/enterprise/:enterpriseId/:code/management',
    component: withRequireAuthentication(InitiativeManagementPage)
  },
  {
    id: 'enterpriseFlow.validateEmail',
    path: '/enterprise/:enterpriseId/:code',
    component: RedirectInitiativeAuthService
  }
]

export default routes
